const loadingMethodsIds = {
  sideId: 'debae407-c48e-4b45-8d7c-33b7886e7458',
  topId: 'a940d693-da22-449e-85cb-9ce8cb7b39cc',
};

export default loadingMethodsIds;
